import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const useAVERAGE_FORM_REPLIES_AMOUNT_BY_PERIOD_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'AVERAGE_FORM_REPLIES_AMOUNT_BY_PERIOD',
    name: t('widgets.averageFormRepliesAmountByPeriod.name'),
    description: t('widgets.averageFormRepliesAmountByPeriod.description'),
    color: 'blue',
    icon: 'RiBarChartHorizontalFill',
    categories: [t('widgets.averageFormRepliesAmountByPeriod.category')],
    previewWidth: '65%',

    initialState: {
      size: { width: 50, height: 400 },
      data: { periodType: 'day_of_week' }
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
